import React from "react";
import SetTitle from "../../components/SetTitle";
import PinLeft from "../../assets/images/PinLeft.png";
import PinRight from "../../assets/images/PinRight.png";
import Gallery1 from "../../assets/images/Gallery1.jpg";
import styles from "./Gallery.module.scss";

const ImgSrc = 'https://picsum.photos/200/300';

const Gallery = () => {
	SetTitle("Gallery");

	return (
		<div className={styles.Gallery}>
			<h2>Our Gallery</h2>

			<div className={styles.ImageContainer}>
				<div className={styles.Row}>
					<div className={`${styles.ImgWrapper} ${styles.Left}`}>
						<img src={PinLeft} alt="PinLeft" className={styles.PinLeft} />
						<img src={PinRight} alt="PinRight" className={styles.PinRight} />

						<div className={styles.InnerImage}>
							<img src={Gallery1} alt="Kids Craft Activity" />
						</div>
					</div>

					<div className={`${styles.ImgWrapper} ${styles.Right}`}>
						<img src={PinLeft} alt="PinLeft" className={styles.PinLeft} />
						<img src={PinRight} alt="PinRight" className={styles.PinRight} />

						<div className={styles.InnerImage}>
							<img src={ImgSrc} alt="" />
						</div>
					</div>
				</div>

				<div className={styles.Row}>
					<div className={`${styles.ImgWrapper} ${styles.Left}`}>
						<img src={PinLeft} alt="PinLeft" className={styles.PinLeft} />
						<img src={PinRight} alt="PinRight" className={styles.PinRight} />
						<div className={styles.InnerImage}>
							<img src={ImgSrc} alt="" />
						</div>
					</div>
					<div className={`${styles.ImgWrapper} ${styles.Right}`}>
						<img src={PinLeft} alt="PinLeft" className={styles.PinLeft} />
						<img src={PinRight} alt="PinRight" className={styles.PinRight} />
						<div className={styles.InnerImage}>
							<img src={ImgSrc} alt="" />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Gallery;
